import React from "react"
import { Alert, Typography } from "@carrotfertility/carotene-core"
import { FormattedMessage, FormattedNumber } from "react-intl"
import type { BookingPaymentOptions } from "../../hooks"
import { InsuranceRecoveryFooter } from "./InsuranceRecoveryFooter"

type InsuranceUnavailableProps = {
  reason: "notCovered" | "noProviders"
  paymentOptions: BookingPaymentOptions
  onContinue: () => void
}

export function InsuranceUnavailableStep({
  reason,
  paymentOptions,
  onContinue
}: InsuranceUnavailableProps): JSX.Element {
  const cost =
    paymentOptions.selfPay.status === "available" ? (
      <FormattedNumber
        value={paymentOptions.selfPay.amountMinorUnits / 100}
        // eslint-disable-next-line react/style-prop-object -- style prop is valid for FormattedNumber
        style="currency"
        currency={paymentOptions.selfPay.currency}
        maximumFractionDigits={2}
        minimumFractionDigits={paymentOptions.selfPay.amountMinorUnits % 100 === 0 ? 0 : 2}
      />
    ) : null
  if (reason === "notCovered") {
    return (
      <>
        <Alert severity="error">
          <FormattedMessage defaultMessage="Your insurance plan doesn't cover this type of appointment." />
        </Alert>
        <Typography variant="h4" component="h1">
          <FormattedMessage defaultMessage="You can still book and pay out of pocket" />
        </Typography>
        <Typography>
          {paymentOptions.selfPay.status === "available" ? (
            <FormattedMessage defaultMessage="Appointments are {cost}." values={{ cost }} />
          ) : (
            <FormattedMessage defaultMessage="Self-pay pricing is currently unavailable." />
          )}
        </Typography>
        <InsuranceRecoveryFooter onContinue={onContinue} />
      </>
    )
  }
  return (
    <>
      <Alert severity="info">
        <FormattedMessage defaultMessage="Your insurance plan covers this type of appointment" />
      </Alert>
      <Typography variant="h4" component="h1">
        <FormattedMessage defaultMessage="No in-state clinicians accept your insurance right now" />
      </Typography>
      <Typography>
        <FormattedMessage defaultMessage="You can still book and pay out of pocket - or check back later." />{" "}
        {paymentOptions.selfPay.status === "available" ? (
          <FormattedMessage defaultMessage="Appointments are {cost}." values={{ cost }} />
        ) : (
          <FormattedMessage defaultMessage="Self-pay pricing is currently unavailable." />
        )}
      </Typography>
      <InsuranceRecoveryFooter onContinue={onContinue} />
    </>
  )
}
